// M4 — Manager tour: Orders. 3 steps on /orders.
export default {
  key: 'M4',
  route: '/orders',
  steps: [
    {
      id: 'list',
      target: '[data-tour-id="orders.list.table"]',
      title: 'Orders',
      desc: 'Orders represent approved customer work moving through production.',
    },
    {
      id: 'status-workflow',
      target: '[data-tour-id="orders.status-filter"]',
      title: 'Status workflow',
      desc: 'Orders progress through statuses (new, ordered, in-production, completed). Filter the list by status here.',
    },
    {
      id: 'priority-due',
      target: '[data-tour-id="orders.list.table"]',
      title: 'Priority & due dates',
      desc: 'Each row shows priority and due date — drive scheduling and shop-floor focus.',
    },
  ],
}
